import React, { Component } from 'react';
import Notificacao from '../Notificacao';
import moment from 'moment';
import ReactHtmlParser, {
  processNodes,
  convertNodeToElement,
  htmlparser2
} from 'react-html-parser';
export default class RiscoCirurgico extends Component {
  state = {
    comentario: '',
    ref: null,
    alertMsg: null,
    status: null,
    openModal: false,
    cidade: '',
    paciente: null
  };

  render() {
    return (
      <div>
        <div
          id="react-no-print"
          className="container"
          style={{
            overflowY: 'scroll',
            overflowX: 'hidden',
            maxHeight: '80vh'
          }}
        >
          <div className="col">
            <h4>Risco Cirúrgico</h4> <br />
            <br />
            <p>
              Exames Laboratoriais:{' '}
              {ReactHtmlParser(
                this.props.item.riscoCirurgico.examesLaboratoriais
              )}
            </p>
            <p>
              Resultados Henograma:{' '}
              {ReactHtmlParser(
                this.props.item.riscoCirurgico.resultadosHenograma
              )}
            </p>
            <p>
              Eletro Cardiograma:{' '}
              {ReactHtmlParser(
                this.props.item.riscoCirurgico.eletroCardiograma
              )}
            </p>
            <p>
              Raio X: {ReactHtmlParser(this.props.item.riscoCirurgico.raiox)}
            </p>
            <p>
              Exames E Vacinas:{' '}
              {ReactHtmlParser(this.props.item.riscoCirurgico.examesVacinas)}
            </p>
            <p>
              <br />
              {moment(
                this.props.item.riscoCirurgico.DataCriacao,
                'DD-MM-YYYY'
              ).format('DD/MM/YYYY')}
            </p>
            {this.props.item.riscoCirurgico.midias
              ? this.props.item.riscoCirurgico.midias.map(item => {
                  return (
                    <a href={item} target="_Blank">
                    <img
                      style={{ width: '150px', height: '150px' }}
                      src={item}
                      alt="new"
                    />
                    </a>
                  );
                })
              : null}
          </div>
          <br />

          {this.state.notifition ? (
            <Notificacao
              msg={this.state.msg}
              nameclass={this.state.nameclass}
            />
          ) : null}
        </div>
      </div>
    );
  }
}
